document.addEventListener('DOMContentLoaded', function () {
  const testimonialSwiper = new Swiper('.testimonial-custom-swiper', {
    loop: false,
    spaceBetween: 25,
    pagination: {
      el: '.testimonial-swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 10,
      },
      750: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 20,
      },
      1100: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        grid: {
          rows: 1
        },
        spaceBetween: 25,
      }
    }
  });

  window.addEventListener('resize', function () {
    testimonialSwiper.update();
  });
});
